/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { OasResponse } from '../../openapi/models/OasResponse';
import { OasResponses } from '../../openapi/models/OasResponses';

/**
 * A command used to delete a single response from an operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteResponseCommand extends AbstractCommand {
    public _responseCode : string;

    public _responsePath : NodePath;

    public _responsesPath : NodePath;

    public _oldResponse : any;

    public constructor(response? : any) {
        if(((response != null && response instanceof <any>OasResponse) || response === null)) {
            let __args = arguments;
            super();
            if(this._responseCode===undefined) this._responseCode = null;
            if(this._responsePath===undefined) this._responsePath = null;
            if(this._responsesPath===undefined) this._responsesPath = null;
            if(this._oldResponse===undefined) this._oldResponse = null;
            if(this._responseCode===undefined) this._responseCode = null;
            if(this._responsePath===undefined) this._responsePath = null;
            if(this._responsesPath===undefined) this._responsesPath = null;
            if(this._oldResponse===undefined) this._oldResponse = null;
            (() => {
                this._responseCode = response.getStatusCode();
                this._responsePath = Library.createNodePath(response);
                this._responsesPath = Library.createNodePath(response.parent());
            })();
        } else if(response === undefined) {
            let __args = arguments;
            super();
            if(this._responseCode===undefined) this._responseCode = null;
            if(this._responsePath===undefined) this._responsePath = null;
            if(this._responsesPath===undefined) this._responsesPath = null;
            if(this._oldResponse===undefined) this._oldResponse = null;
            if(this._responseCode===undefined) this._responseCode = null;
            if(this._responsePath===undefined) this._responsePath = null;
            if(this._responsesPath===undefined) this._responsesPath = null;
            if(this._oldResponse===undefined) this._oldResponse = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteResponseCommand] Executing.");
        this._oldResponse = null;
        let response : OasResponse = <OasResponse>this._responsePath.resolve(document);
        if(this.isNullOrUndefined(response)) {
            return;
        }
        let responses : OasResponses = <OasResponses>response.parent();
        if(this.isNullOrUndefined(this._responseCode)) {
            responses.default_ = null;
        } else {
            responses.removeResponse(this._responseCode);
        }
        this._oldResponse = Library.writeNode(response);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteResponseCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldResponse)) {
            return;
        }
        let responses : OasResponses = <OasResponses>this._responsesPath.resolve(document);
        if(this.isNullOrUndefined(responses)) {
            return;
        }
        let response : OasResponse = responses.createResponse(this._responseCode);
        Library.readNode(this._oldResponse, response);
        if(this.isNullOrUndefined(this._responseCode)) {
            responses.default_ = response;
        } else {
            responses.addResponse(this._responseCode, response);
        }
    }
}
DeleteResponseCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteResponseCommand";
DeleteResponseCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

